import { TableFormList } from "components/formList";
import {
  useCreateCreditorContactMutation,
  useDeleteCreditorContactMutation,
  useFetchCreditorContactsQuery,
  useUpdateCreditorContactMutation,
} from "features/creditors/agencyPortal/creditorsAPI";

export default function CreditorContactsStep({ creditorId }) {
  const { data: creditorContacts, isLoading } = useFetchCreditorContactsQuery(
    {
      creditorId,
    },
    { skip: !creditorId },
  );
  const [updateCreditorContact] = useUpdateCreditorContactMutation();
  const [deleteCreditorContact] = useDeleteCreditorContactMutation();
  const [createCreditorContact] = useCreateCreditorContactMutation();

  const columns = [
    {
      dataIndex: "name",
      editable: true,
      inputType: "text",
      title: "Name",
      rules: [
        {
          required: true,
          pattern: /^[a-zA-Z'"\-\d ]{2,30}$/,
          message: "Name must be alphanumeric",
        },
      ],
    },
    {
      dataIndex: "title",
      editable: true,
      inputType: "text",
      title: "Title",
    },
    {
      dataIndex: "role",
      render: (_, record) =>
        ({
          account_manager: "Account Manager",
          accountant: "Accountant",
          owner: "Owner",
          primary_contact: "Primary Contact",
          secondary_contact: "Secondary Contact",
          senior_management: "Senior Management",
          decision_maker: "Decision Maker",
          accounts_payable_contact: "Accounts Payable Contact",
          collection_contact: "Collection Contact",
          other: "Other",
        }[record.role]),
      editable: true,
      inputType: "select",
      rules: [{ required: true, message: "Please select role" }],
      options: [
        { label: "Account Manager", value: "account_manager" },
        { label: "Accountant", value: "accountant" },
        { label: "Owner", value: "owner" },
        { label: "Primary Contact", value: "primary_contact" },
        { label: "Secondary Contact", value: "secondary_contact" },
        { label: "Senior Management", value: "senior_management" },
        { label: "Decision Maker", value: "decision_maker" },
        { label: "Accounts Payable Contact", value: "accounts_payable_contact" },
        { label: "Collection Contact", value: "collection_contact" },
        { label: "Other", value: "other" },
      ],
      title: "Role",
    },
    {
      dataIndex: "workPhone",
      editable: true,
      inputType: "text",
      title: "Work Phone",
      rules: [
        {
          pattern:
            /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/,
          message: "Enter a valid phone number",
        },
      ],
    },
    {
      dataIndex: "cellPhone",
      editable: true,
      inputType: "text",
      rules: [
        {
          pattern:
            /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/,
          message: "Enter a valid phone number",
        },
      ],
      title: "Cell Phone",
    },
    {
      dataIndex: "email",
      editable: true,
      inputType: "text",
      rules: [
        {
          pattern:
            /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i,
          message: "Enter a valid email",
        },
      ],
      title: "Email",
    },
    {
      dataIndex: "fax",
      editable: true,
      inputType: "text",
      rules: [
        {
          pattern:
            /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/,
          message: "Enter a valid phone number",
        },
      ],
      title: "Fax",
    },
    {
      dataIndex: "notes",
      editable: true,
      inputType: "textArea",
      title: "Notes",
    },
  ];

  return (
    <TableFormList
      loading={isLoading}
      columns={columns}
      data={creditorContacts}
      onDelete={(contact) =>
        deleteCreditorContact({
          creditorId,
          contact,
        })
      }
      onSave={(contact) => {
        const action = contact.id ? updateCreditorContact : createCreditorContact;
        return action({
          creditorId,
          contact,
        });
      }}
    />
  );
}
